// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__M-FUL","loader_animation":"loader_loader_animation__TMxYF","loader_container":"loader_loader_container__1YRcp"};